import { $emit as f } from "../utils/gogocodeTransfer.js";
import { numberFormat as d } from "../utils/util.js";
import { openBlock as l, createElementBlock as a, createElementVNode as i, toDisplayString as o, renderSlot as v, Fragment as b, withDirectives as y, vShow as g, createCommentVNode as u, normalizeClass as c, createTextVNode as _ } from "vue";
import { _ as p } from "../_plugin-vue_export-helper-dad06003.js";
import "../_commonjsHelpers-ce4d82cc.js";
import "numbro";
function w() {
  const t = this.$attrs;
  t.class && this.$el.classList.add(t.class), t.style && Object.entries(t.style).forEach(([n, s]) => {
    this.$el.style[n] = s;
  });
}
const V = {
  name: "rAssetsProfile",
  inheritAttrs: !1,
  props: {
    /**
     * 判断资产是否展示，默认展示资产数值
     */
    value: {
      type: Boolean,
      default: !0
    },
    /**
     * 标题
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * 占主位的数字，类型可以是字符串或者数字，但是都必须是纯数字，如果包含非法字符，则会直接展示，不做格式化处理
     */
    amount: {
      type: [String, Number],
      default: void 0
    },
    /**
     * 主位数字单位
     */
    amountCoin: {
      type: String,
      default: ""
    },
    /**
     * 占副位的数字，类型可以是字符串或者数字，但是都必须是纯数字，如果包含非法字符（，--等），则会直接展示，不做格式化处理
     */
    valuation: {
      type: [String, Number],
      default: void 0
    },
    /**
     * 副位数字单位
     */
    valuationCoin: {
      type: String,
      default: ""
    },
    /**
     * 是否开启隐私保护
     */
    showPrivacy: {
      type: Boolean,
      default: !1
    },
    /**
     * 是否展示正负号，适用于今日收益等需要展示正负号，涨跌幅等情况
     */
    showPlusMinus: {
      type: Boolean,
      default: !1
    },
    /**
     * 千分位格式化，默认为ture
     */
    formatTenPercentile: {
      type: Boolean,
      default: !0
    },
    /**
     * 主资产和转化资产之间的符号，默认为≈
     */
    symbol: {
      type: String,
      default: "≈"
    },
    /**
     * 针对非首个资金的时候，字体大小有差别
     */
    isSub: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      assetsVisible: this.value
    };
  },
  methods: {
    onChangeVisible() {
      this.assetsVisible = !this.assetsVisible, f(this, "update:value", this.assetsVisible), f(this, "change", this.assetsVisible);
    },
    plusMinusStyle(t) {
      return this.showPlusMinus && this.assetsVisible ? t.startsWith("-") ? "is-minus" : "is-plus" : null;
    }
  },
  computed: {
    formatAmount() {
      return this.formatTenPercentile || this.showPlusMinus ? d(this.amount, {
        thousandSeparated: this.formatTenPercentile,
        forceSign: this.showPlusMinus
      }) : this.amount;
    },
    formatValuation() {
      return this.formatTenPercentile || this.showPlusMinus ? d(this.valuation, {
        thousandSeparated: this.formatTenPercentile,
        forceSign: this.showPlusMinus
      }) : this.valuation;
    }
  },
  watch: {
    value(t) {
      this.assetsVisible = t;
    }
  },
  mounted() {
    w.call(this);
  },
  emits: ["update:value", "change"]
}, S = { class: "r-assets-profile" }, M = { class: "header" }, P = { class: "title" }, C = /* @__PURE__ */ i(
  "path",
  { d: "M258.385 168.22c-48.48 0-87.781 39.3-87.781 87.78s39.3 87.781 87.781 87.781c48.481 0 87.781-39.3 87.781-87.781 0-48.48-39.3-87.781-87.781-87.781zM199.864 256c0-32.32 26.201-58.52 58.52-58.52 32.321 0 58.52 26.201 58.52 58.52 0 32.321-26.199 58.52-58.52 58.52-32.32 0-58.52-26.199-58.52-58.52z" },
  null,
  -1
  /* HOISTED */
), k = /* @__PURE__ */ i(
  "path",
  { d: "M256 95.069c-104.401 0-193.744 64.321-230.627 155.441l-2.223 5.489 2.223 5.489c36.885 91.122 126.227 155.441 230.627 155.441s193.744-64.32 230.626-155.442l2.224-5.489-2.224-5.489c-36.882-91.12-126.226-155.441-230.626-155.441zM256 387.671c-89.966 0-167.321-54.14-201.196-131.671 33.875-77.529 111.23-131.671 201.196-131.671s167.318 54.142 201.196 131.671c-33.877 77.531-111.23 131.671-201.196 131.671z" },
  null,
  -1
  /* HOISTED */
), z = [
  C,
  k
], B = /* @__PURE__ */ i(
  "path",
  { d: "M56.249 62.547c5.812-5.811 15.234-5.811 21.045 0l52.767 52.767c37.081-21.328 80.081-33.528 125.939-33.528 106.191 0 197.067 65.424 234.581 158.107l2.262 5.584-2.262 5.583c-20.536 50.736-57.060 93.301-103.334 121.44l55.908 55.908c5.813 5.81 5.813 15.232 0 21.045-5.813 5.81-15.235 5.81-21.045 0l-62.438-62.438-0.512 0.232-22.759-22.759 0.536-0.208-210.97-210.97-0.433 0.312-21.285-21.285 0.425-0.319-48.427-48.427c-5.811-5.811-5.811-15.233 0-21.045zM207.458 192.71c1.161-1.305 2.368-2.584 3.619-3.835 34.87-34.868 91.399-34.868 126.269 0s34.869 91.403 0 126.269c-1.25 1.253-2.53 2.458-3.837 3.62l31.988 31.988c42.065-23.724 75.673-60.7 95.149-105.273-34.459-78.859-113.137-133.929-204.646-133.929-37.563 0-72.964 9.279-104.031 25.673l55.489 55.489zM228.557 213.81l83.854 83.854c1.337-1.122 2.634-2.31 3.89-3.565 23.247-23.244 23.247-60.934 0-84.179-23.244-23.246-60.935-23.246-84.179 0-1.256 1.256-2.445 2.554-3.565 3.89z" },
  null,
  -1
  /* HOISTED */
), x = /* @__PURE__ */ i(
  "path",
  { d: "M70.999 162.22c-20.956 22.46-37.87 48.739-49.581 77.674l-2.261 5.584 2.26 5.583c37.517 92.684 128.392 158.107 234.583 158.107 19.166 0 37.834-2.131 55.777-6.17l-25.613-25.613c-9.866 1.334-19.935 2.021-30.163 2.021-91.51 0-170.19-55.069-204.646-133.928 10.059-23.021 23.886-44.014 40.701-62.202l-21.055-21.055z" },
  null,
  -1
  /* HOISTED */
), A = [
  B,
  x
], T = {
  key: 0,
  class: "coin-amount"
}, N = {
  key: 1,
  class: "coin-symbol"
}, D = {
  key: 0,
  class: "price-symbol"
};
function E(t, n, s, F, r, e) {
  return l(), a("div", S, [
    i("div", M, [
      i(
        "span",
        P,
        o(s.title),
        1
        /* TEXT */
      ),
      v(t.$slots, "icon", {}, () => [
        s.showPrivacy ? (l(), a(
          b,
          { key: 0 },
          [
            y((l(), a(
              "svg",
              {
                class: "icon svgfont",
                onClick: n[0] || (n[0] = (...h) => e.onChangeVisible && e.onChangeVisible(...h)),
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "512",
                height: "512",
                viewBox: "0 0 512 512"
              },
              z,
              512
              /* NEED_PATCH */
            )), [
              [g, r.assetsVisible]
            ]),
            y((l(), a(
              "svg",
              {
                class: "icon svgfont",
                onClick: n[1] || (n[1] = (...h) => e.onChangeVisible && e.onChangeVisible(...h)),
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "512",
                height: "512",
                viewBox: "0 0 512 512"
              },
              A,
              512
              /* NEED_PATCH */
            )), [
              [g, !r.assetsVisible]
            ])
          ],
          64
          /* STABLE_FRAGMENT */
        )) : u("v-if", !0)
      ])
    ]),
    i(
      "div",
      {
        class: c(["profile", s.isSub ? "sub-title" : ""])
      },
      [
        u(" 要做千分位 "),
        i(
          "span",
          {
            class: c(["left-amount", e.plusMinusStyle(e.formatAmount)])
          },
          [
            s.amount ? (l(), a(
              "span",
              T,
              o(r.assetsVisible ? e.formatAmount : "******"),
              1
              /* TEXT */
            )) : u("v-if", !0),
            s.amount ? (l(), a(
              "span",
              N,
              o(s.amountCoin),
              1
              /* TEXT */
            )) : u("v-if", !0)
          ],
          2
          /* CLASS */
        ),
        s.valuation ? (l(), a(
          "span",
          {
            key: 0,
            class: c(["right-amount", e.plusMinusStyle(e.formatValuation)])
          },
          [
            _(
              o(s.symbol) + " ",
              1
              /* TEXT */
            ),
            i(
              "span",
              {
                class: c(e.plusMinusStyle(e.formatValuation))
              },
              [
                _(
                  o(r.assetsVisible ? e.formatValuation : "******") + " ",
                  1
                  /* TEXT */
                ),
                s.valuation ? (l(), a(
                  "span",
                  D,
                  o(s.valuationCoin),
                  1
                  /* TEXT */
                )) : u("v-if", !0)
              ],
              2
              /* CLASS */
            )
          ],
          2
          /* CLASS */
        )) : u("v-if", !0),
        v(t.$slots, "extra")
      ],
      2
      /* CLASS */
    )
  ]);
}
const m = /* @__PURE__ */ p(V, [["render", E], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/assets-profile/assets-profile.vue"]]);
m.install = function(t) {
  t.component(m.name, m);
};
export {
  m as default
};
